import { DateTime } from 'luxon';
import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import * as FilteredPermitsState from '../state/FilteredPermitsState.ts';
import * as ClearancePermitListState from '../state/ClearancePermitListState.ts';
import { ElementNamer } from 'dg-web-shared/lib/ReactHelpers.tsx';
import { fromDateConstraint, toDateConstraint } from './shared.ts';

const an = ElementNamer('clearance-permit-list-FilterPermitsActions');

export const setValidDateFrom = (s: Flux.Store, d: DateTime): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        validDateFrom: d,
        validDateTo: toDateConstraint(
            d,
            FilteredPermitsState.Filter.get(s).validDateTo,
        ),
    });
    FilteredPermitsState.List.reset(s);
    return an('setValidDateFrom');
};
export const setValidDateTo = (s: Flux.Store, d: DateTime): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        validDateTo: d,
        validDateFrom: fromDateConstraint(
            d,
            FilteredPermitsState.Filter.get(s).validDateFrom,
        ),
    });
    FilteredPermitsState.List.reset(s);
    return an('setValidDateTo');
};
export const clearValidDate = (s: Flux.Store): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        validDateFrom: null,
        validDateTo: null,
    });
    FilteredPermitsState.List.reset(s);
    return an('clearValidDate');
};

export const setPermitTypes = (s: Flux.Store, pt: number[]): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        permitTypes: pt.length === 0 ? null : pt,
    });
    FilteredPermitsState.List.reset(s);
    return an('setPermitTypes');
};
export const clearPermitTypes = (s: Flux.Store): string => {
    FilteredPermitsState.Filter.stateWrite(s, { permitTypes: null });
    FilteredPermitsState.List.reset(s);
    return an('clearPermitTypes');
};

export const setOperatorLogins = (s: Flux.Store, ol: number[]): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        operatorLogins: ol.length === 0 ? null : ol,
    });
    FilteredPermitsState.List.reset(s);
    return an('setOperatorLogins');
};
export const clearOperatorLogins = (s: Flux.Store): string => {
    FilteredPermitsState.Filter.stateWrite(s, { operatorLogins: null });
    FilteredPermitsState.List.reset(s);
    return an('clearOperatorLogins');
};

export const setIssueDateFrom = (s: Flux.Store, d: DateTime): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        issueDateFrom: d,
        issueDateTo: toDateConstraint(
            d,
            FilteredPermitsState.Filter.get(s).issueDateTo,
        ),
    });
    FilteredPermitsState.List.reset(s);
    return an('setIssueDateFrom');
};
export const setIssueDateTo = (s: Flux.Store, d: DateTime): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        issueDateTo: d,
        issueDateFrom: fromDateConstraint(
            d,
            FilteredPermitsState.Filter.get(s).issueDateFrom,
        ),
    });
    FilteredPermitsState.List.reset(s);
    return an('setIssueDateTo');
};
export const clearIssueDate = (s: Flux.Store): string => {
    FilteredPermitsState.Filter.stateWrite(s, {
        issueDateFrom: null,
        issueDateTo: null,
    });
    FilteredPermitsState.List.reset(s);
    return an('clearIssueDate');
};

export const clearFilter = (s: Flux.Store) => {
    FilteredPermitsState.Filter.stateWrite(s, {
        validDateFrom: null,
        validDateTo: null,
        permitTypes: null,
        operatorLogins: null,
        issueDateFrom: null,
        issueDateTo: null,
        timeLimit: null,
        channel: null,
        cost: null,
        status: null,
    });
    FilteredPermitsState.FilterSummary.stateWrite(s, { hover: false });
    FilteredPermitsState.List.reset(s);
    return an('clearFilter');
};

export const selectFilteredPermitsTab = (s: Flux.Store) => {
    ClearancePermitListState.Layout.stateWrite(s, {
        selectedTab: ClearancePermitListState.SelectedTab.FilteredPermits,
    });
    return an('selectFilteredPermitsTab');
};
